import Vue from 'vue';
import Router from 'vue-router';
// eslint-disable-next-line import/no-cycle
import store from '@/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('./views/Login.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('./views/admin/Reports/index.vue'),
      meta: { requiresAuth: true, requiresOwner: true }
    },
    {
      path: '/metrics',
      name: 'metrics',
      component: () => import('./views/admin/Metrics/index.vue'),
    },
    {
      path: '/conference',
      name: 'conference',
      component: () => import('./views/admin/Conference/index.vue'),
    },
    {
      path: '/billing',
      name: 'billing',
      component: () => import('./views/admin/Reports/Subscriptions.vue'),
      meta: { requiresAuth: true, requiresOwner: true }
    },
    {
      path: '/jobs',
      name: 'reports',
      component: () => import('./views/admin/Reports/Jobs.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/deflector',
      name: 'deflector',
      component: () => import('./views/admin/Reports/Deflector.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/manager',
      name: 'manager',
      component: () => import('./views/admin/Manager/index.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/user/:id',
      name: 'user',
      component: () => import('./views/admin/Manager/User.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/user/:id/settings',
      name: 'settings',
      component: () => import('./views/admin/Manager/UserSettings.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/job/:id',
      name: 'user',
      component: () => import('./views/admin/Manager/Job.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '*',
      redirect: '/',
      meta: { requiresAuth: true, requiresAdmin: true }
    },
  ],
});

// Handle routing security and user sync
router.beforeEach(async (to, from, next) => {
  // perform admin check
  if (to.meta.requiresAdmin) {
    try {
      await store.dispatch('SYNC_USER_TO_DB');
    } catch (err) {
      console.log('ERROR!', err);
    }
    if (store.getters.hasRole === 'user') {
      next('/');
    }
    next();
  // perform owner check
  } else if (to.meta.requiresOwner) {
    try {
      await store.dispatch('SYNC_USER_TO_DB');
    } catch (err) {
      console.log('ERROR!', err);
    }
    if (store.getters.hasRole !== 'owner') {
      next('/manager');
    }
    next();
  }

  // perform standard auth check
  if (to.meta.requiresAuth === true) {
    if (store.getters.isLoggedIn) {
      if (store.state && store.state.user === null) {
        try {
          await store.dispatch('SYNC_USER_TO_DB');
        } catch (err) {
          console.log('ERROR!', err);
        }
      }
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

export default router;
